import { SceneKeys, type SceneKey } from '@/core/scenes/keys';
import type { StoryFlagId } from './flags';
import type { StoryState } from './flags';

export interface RouteEntry { scene: SceneKey; spawn: string; resumeFlag: StoryFlagId | null }

/**
 * Where a fresh start / refresh / load should enter, given the current story state.
 * Never resumes mid-cinematic: it re-enters at the beginning of the next beat.
 */
export function resolveEntry(state: StoryState): RouteEntry {
  const cur = state.current();
  switch (cur) {
    case null:
    case 'TITLE':
      return { scene: SceneKeys.PROLOGUE, spawn: 'letter-desk', resumeFlag: cur };
    case 'LETTER_OPEN':
    case 'MEMORY_STORM':
    case 'MEMORY_ISLAND_RITUAL':
    case 'MEMORY_BLACK_WATER':
    case 'MEMORY_FAREWELL':
    case 'MEMORY_SWORD_TRAINING':
      return { scene: SceneKeys.PROLOGUE, spawn: 'letter-desk', resumeFlag: cur };
    case 'LETTER_SENT':
      return { scene: SceneKeys.PROLOGUE, spawn: 'letter-desk', resumeFlag: cur };
    case 'PROPHECY_REVEAL':
      return { scene: SceneKeys.GREEN_HARBOR, spawn: 'pier-start', resumeFlag: cur };
    case 'HARBOR_FREE_ROAM':
    case 'MERCHANT_TURTLE_EGG':
      return { scene: SceneKeys.GREEN_HARBOR, spawn: 'market', resumeFlag: cur };
    case 'RAIN_APPROACHES':
      return { scene: SceneKeys.GREEN_HARBOR, spawn: 'inn-approach', resumeFlag: cur };
    case 'INN_ARGUMENT':
      return { scene: SceneKeys.TURTLE_INN, spawn: 'inn-entrance', resumeFlag: cur };
    case 'OMEN_END':
      return { scene: SceneKeys.CHAPTER_END, spawn: 'end', resumeFlag: cur };
  }
}
